module.exports={Earlier:"FRÜHER",New:"NEU",NoAnnouncements:"Sie haben keine Ankündigungen"};